import React from 'react';
import { Row } from 'react-bootstrap';
import { FormFilterCard, FormCol } from 'motion-components';
import * as Yup from 'yup';
import { SelectYear } from '../../components/select-year';
import { useTranslation } from 'react-i18next';
import { FieldSelectMaterial } from 'shared-pages/components';
import { splitGmtFromDate } from 'motion-components';
import { useRootStore } from 'store';
import { FieldSelectCollector } from 'shared-pages/components';

/* ----------- Filters ------------------ */
export const Filters = ({ onChange, initialValues }) => {
  const { appStore } = useRootStore();
  const { t } = useTranslation();
  function handleFiltersSubmit(values, { setSubmitting }) {
    setTimeout(() => {
      setSubmitting(false);
      const startDate = new Date(values.year, 0, 1);
      const endDate = new Date(values.year, 11, 31, 23, 59, 59);
      const materialId = values.materialId;
      onChange({
        startDate: splitGmtFromDate(startDate),
        endDate: splitGmtFromDate(endDate),
        materialId,
        collectorId: values.collectorId,
      });
    }, 400);
  }

  const filters = {
    year: initialValues?.year ?? new Date().getFullYear(),
    materialId: initialValues?.materialId ?? undefined,
    collectorId: initialValues?.collectorId ?? undefined,
  };

  const formShape = {
    year: Yup.string().required('Το Έτος είναι υποχρεωτικό'),
    materialId: Yup.number().required('Το Απόβλητο είναι υποχρεωτικό'),
    collectorId: Yup.number().nullable(),
  };

  const validationSchema = Yup.object().shape(formShape);
  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
      validationSchema={validationSchema}
    >
      <Row>
        <SelectYear name="year" title="Έτος" required={true} as={FormCol} />
        {/* <SelectMonth name="month" title="Μήνας" required={true} as={FormCol} /> */}
        <FieldSelectMaterial as={FormCol} />
        {appStore.isPlatformOwner && (
          <FieldSelectCollector as={FormCol} name="collectorId" label={t('Συλλέκτης')} />
        )}
      </Row>
    </FormFilterCard>
  );
};
